import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import './LegalShared.css';

const SustainabilityPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="legal-page-shared">
      <div className="legal-container">
        <nav className="legal-top-nav">
          <button onClick={() => navigate(-1)} className="back-link-gold">
            <ArrowLeft size={18} />
            <span>GO BACK</span>
          </button>
        </nav>
        
        <header className="legal-header-main">
          <h1 className="legal-title-gold">Sustainability</h1>
          <p className="legal-subtitle-white">Our botanical ethos.</p>
        </header>

        <section className="legal-brief-box">
          <span className="brief-label">IN BRIEF</span>
          <p className="brief-text-gold">Our commitment to the earth is as deep as our base notes. We source with ethics, bottle for eternity, and distill with a heart focused on the future of our botanical world.</p>
        </section>

        <div className="legal-content-grid">
          <article className="legal-section-card">
            <span className="section-tag">ARTICLE 01</span>
            <h2 className="section-heading-gold">Ethical Harvesting</h2>
            <p className="section-text-white">We partner with sustainable plantations for our rare Sandalwood and employ ethical, non-harmful beach-collection for our precious Ambergris. We believe luxury should never come at a biological cost.</p>
          </article>

          <article className="legal-section-card">
            <span className="section-tag">ARTICLE 02</span>
            <h2 className="section-heading-gold">Crystal Longevity</h2>
            <p className="section-text-white">Our vessels are designed as heirlooms, meant to be kept for a lifetime. Through our 'Refill Ritual' program, we significantly reduce waste by offering high-concentration refills in eco-friendly minimalist packaging.</p>
          </article>

          <article className="legal-section-card">
            <span className="section-tag">ARTICLE 03</span>
            <h2 className="section-heading-gold">Green Distillation</h2>
            <p className="section-text-white">Our global atelier is powered by 100% renewable energy. We utilize proprietary low-heat extraction methods that preserve the fragile molecules of rare botanicals while minimizing our carbon footprint.</p>
          </article>
        </div>

        <div className="legal-bottom-nav" style={{ marginTop: '80px', display: 'flex', justifyContent: 'center' }}>
          <button onClick={() => navigate(-1)} className="back-link-gold">
            <ArrowLeft size={18} />
            <span>RETURN TO ATELIER</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default SustainabilityPage;
